import api from '../../api/index';
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    appId: {
      type: String,
      required: true,
      value: "",
    },
    alive_id: {
      type: String,
      required: true,
      value: "",
    },
    userId: {
      type: String,
      required: true,
      value: "",
    },
  },

  /**
   * 组件的初始数据
   */
  data: {
    stateMap: {
      1: '进行中',
      2: '已结束',
      3: '已过期',
    },
    redPacketList: [],
  },

  /**
   * 组件的方法列表
   */
  methods: {
    toDetail(e) {
      let id=e.currentTarget.dataset.id;
      this.triggerEvent('paramId',{red_packet_id:id})
    },
    getRedPacketList(){
      wx.showLoading({
        title: '加载中',
      })
      let params = {
        app_id: this.data.appId,
        alive_id: this.data.alive_id,
        user_id: this.data.userId,
        page:1,
        limit:1000
      }
      api.getRedPacketList(params).then(response => {
        wx.hideLoading()
        let res=response.data;
        if (res.code === 0) {
          this.setData({
            redPacketList:res.data
          })
        }else{
          wx.showToast({
              title: res.data.msg,
              icon: 'none',
              duration: 2000
          })
        }
      })
    }
  },
  lifetimes: {
    attached: function() {
      this.getRedPacketList()
    }
  }
})
